import React from 'react';
import { postJson, deleteJson } from '../helpers/RequestsHelper';


const ActiveExecutionsContinue = (props) => {

  const [item] = React.useState(props.item)

  const executionInput = async () => {
    await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows/input/" + item.id, {})
    props.onUpdate(item)
  }

  const onDelete = async () => {
    await deleteJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows/input/" + item.id)
    props.onUpdate(item)
  }

  return (
    <div className="apps-group d-flex justify-content-center">

      <div class="p-2">
        <button className="submit-btn-2" onClick={executionInput}>
          {props.block.params && props.block.params.message ? props.block.params.message : "Continue"}
        </button>
      </div>

      <div class="p-2">
        <button className="submit-btn-2 p-2" onClick={onDelete}>Cancel</button>
      </div>
    </div>
  )
}

export default ActiveExecutionsContinue